import { Flex, Heading, Text } from '@buffer-mono/popcorn'

import styles from './StreakHoverCard.module.css'

import type { JSX } from 'react'

/** Copy shown for the Week Streak stat. */
export const STREAK_HOVER_COPY =
  "How many weeks in a row you've shared content."

/**
 * Week Streak scorecard hover card. Keeps the existing streak copy but renders
 * it in the same shell as the other scorecard hover cards for consistency.
 */
export function StreakHoverCard(): JSX.Element {
  return (
    <Flex direction="column" gap="3xs" className={styles.container}>
      <Heading as="h2" size="xs">
        Streak
      </Heading>
      <Text size="sm" color="subtle">
        {STREAK_HOVER_COPY}
      </Text>
    </Flex>
  )
}
